export { parsePhoneNumberFromString as default } from 'libphonenumber-js/core'